"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _useCart = _interopRequireDefault(require("../../hooks/useCart"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CartRoot = _ref => {
  let {
    children,
    isLoggedIn
  } = _ref;
  const cartRef = (0, _react.useRef)();
  const [openCart, setOpenCart] = (0, _react.useState)(false);
  const {
    cart,
    setCart
  } = (0, _useCart.default)({
    cartRef,
    isLoggedIn
  });
  return /*#__PURE__*/_react.default.createElement(_CartContext.default.Provider, {
    value: {
      cart,
      cartRef,
      openCart,
      setCart,
      setOpenCart
    }
  }, children);
};
var _default = exports.default = CartRoot;